import { getLayerTreeExpandedKeysSessionKey } from "./getLayerTreeExpandedKeysSessionKey";

export function getLayerTreeExpandedKeysFromSession(
  projectId: string
): string[] | undefined {
  const key = getLayerTreeExpandedKeysSessionKey(projectId);
  return JSON.parse(sessionStorage.getItem(key)) || undefined;
}
